exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PzAd{margin-top:100px}@media(max-width:1200px){._2PzAd{margin-top:75px}}", ""]);

// exports
exports.locals = {
	"teal": "#00dcb2",
	"grey": "#b4b4b4",
	"headerOffsetContainer": "_2PzAd"
};